import Foundation from "@microsoft/fast-components-foundation-react";
import { ContextMenu as BaseContextMenu } from "@microsoft/fast-components-react-base";
import React from "react";
import { DisplayNamePrefix } from "../utilities";
import { Background } from "../background";
import { neutralLayerFloating } from "@microsoft/fast-components-styles-msft";
class ContextMenu extends Foundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            children: void 0,
            managedClasses: void 0,
            enableAutoFocus: void 0,
        };
    }
    /**
     * Renders the component
     */
    render() {
        return (React.createElement(Background, { value: neutralLayerFloating, tag: null },
            React.createElement(BaseContextMenu, Object.assign({}, this.unhandledProps(), { enableAutoFocus: this.props.enableAutoFocus, managedClasses: this.props.managedClasses }), this.props.children)));
    }
}
ContextMenu.displayName = `${DisplayNamePrefix}ContextMenu`;
ContextMenu.defaultProps = {
    managedClasses: {},
};
export default ContextMenu;
